// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Savings Plans (SAVINGSPLANS)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssavingsplans.html
 *
 * 2025-02-24T21:49:38.356Z
 */
export enum AwsSavingsplansActions {
  /**
   * Grants permission to create a savings plan
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_CreateSavingsPlan.html
   */
  CreateSavingsPlan = 'savingsplans:CreateSavingsPlan',
  /**
   * Grants permission to delete the queued savings plan associated with customers a
   * ccount
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_DeleteQueuedSavingsPlan.html
   */
  DeleteQueuedSavingsPlan = 'savingsplans:DeleteQueuedSavingsPlan',
  /**
   * Grants permission to describe the rates associated with customers savings plan
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_DescribeSavingsPlanRates.html
   */
  DescribeSavingsPlanRates = 'savingsplans:DescribeSavingsPlanRates',
  /**
   * Grants permission to describe the savings plans associated with customers accou
   * nt
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_DescribeSavingsPlans.html
   */
  DescribeSavingsPlans = 'savingsplans:DescribeSavingsPlans',
  /**
   * Grants permission to describe the rates assciated with savings plans offerings
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_DescribeSavingsPlansOfferingRates.html
   */
  DescribeSavingsPlansOfferingRates = 'savingsplans:DescribeSavingsPlansOfferingRates',
  /**
   * Grants permission to describe the savings plans offerings that customer is elig
   * ible to purchase
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_DescribeSavingsPlansOfferings.html
   */
  DescribeSavingsPlansOfferings = 'savingsplans:DescribeSavingsPlansOfferings',
  /**
   * Grants permission to list tags for a savings plan
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_ListTagsForResource.html
   */
  ListTagsForResource = 'savingsplans:ListTagsForResource',
  /**
   * Grants permission to return a savings plan
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_ReturnSavingsPlan.html
   */
  ReturnSavingsPlan = 'savingsplans:ReturnSavingsPlan',
  /**
   * Grants permission to tag a savings plan
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_TagResource.html
   */
  TagResource = 'savingsplans:TagResource',
  /**
   * Grants permission to untag a savings plan
   *
   * See https://docs.aws.amazon.com/savingsplans/latest/APIReference/API_UntagResource.html
   */
  UntagResource = 'savingsplans:UntagResource',
}
